import Impfstelle from '@/types/Impfstelle';
import Arbeitsplatz from '@/types/Arbeitsplatz';
import { SystemEinstellungen } from '@/types/Einstellung';

export type UserRoleType = 'lager' | 'anwender' | 'admin' | 'system';

export class UserRole {
    public fw_users_roles_id: number | null = null;
    public user_id: number | null = null;
    public role: UserRoleType | null = null;
}

export default class User {
    /** PK: fw_user | erforderlich **/
    public user_id: number | null = null;
    /**  | max. 50 Zeichen | erforderlich **/
    public username: string | null = null;
    /**  | max. 100 Zeichen **/
    public password: string | null = null;
    /**  | max. 20 Zeichen | erforderlich **/
    public authdb: string | null = null;
    /**  | max. 20 Zeichen | erforderlich **/
    public rolle: string | null = null;
    /**  | max. 100 Zeichen | erforderlich **/
    public vorname: string | null = null;
    /**  | max. 100 Zeichen | erforderlich **/
    public nachname: string | null = null;
    /**  | max. 50 Zeichen **/
    public titel: string | null = null;
    /**  | max. 250 Zeichen **/
    public email: string | null = null;
    /**  | max. 1 Zeichen | erforderlich **/
    public deaktiviert: string | null = 'n';
    /**  **/
    public gueltig_bis: string | null = null;
    /**  **/
    public pw_gueltig_bis: string | null = null;
    /**  | max. -1 Zeichen **/
    public kommentar: string | null = null;
    /**  **/
    public letzte_anmeldung: string | null = null;
    /**  | max. 50 Zeichen **/
    public telefon: string | null = null;
    /**  | max. 50 Zeichen **/
    public fax: string | null = null;
    /**  | max. 50 Zeichen **/
    public telefon_mobil: string | null = null;
    /**  **/
    public profil_aktualisiert_am: string | null = null;
    /**  | max. 50 Zeichen **/
    public participant_id: string | null = null;
    /** gvOuID ist Primärschlüssel für Organisationseinheit | max. 50 Zeichen **/
    public gv_ou_id: string | null = null;
    /** FK: fw_user **/
    public person_id: number | null = null;

    public impfstelle_id: number | null = null;
    public impfstellen: Impfstelle[] | null = null;
    public arbeitsplaetze: Arbeitsplatz[] | null = null;
    public roles: (string & UserRole)[] | null = null;
    public testsystem: boolean | null = null;
    public elga_login_expiration: string | null = null;
    public elga_access: boolean | null = null;
    public elga_error: string | null = null;
    public release_date: string | null = null;
    public password_new = '';
    public password_new_repeated = '';
    public system_einstellungen: SystemEinstellungen | null = null;

    public get name(): string {
        const name = [];

        if (this.titel) {
            name.push(this.titel);
        }
        if (this.vorname) {
            name.push(this.vorname);
        }
        if (this.nachname) {
            name.push(this.nachname);
        }

        return name.join(' ');
    }

    public get isAdmin(): boolean {
        return this.hasRoles(['admin', 'system']);
    }

    public get rollen(): string {
        return (this.roles ?? []).map((role) => role.slice(0, 1).toUpperCase() + role.slice(1)).join(', ');
    }

    constructor(data?: Partial<User>) {
        Object.assign(this, data);
    }

    public hasRoles(targetRoles: UserRoleType[]): boolean {
        return (this.roles ?? []).some((role) => targetRoles.some((targetRole) => targetRole === role));
    }

    public clone(): User {
        return new User(this);
    }
}
